export class ClientListItem {
  constructor(id, name, discount, contactInfo) {
    this.id = id;
    this.name = name;
    this.discount = discount;
    this.contactInfo = contactInfo;
  }

  get autocompleteLabel() {
    return `${this.id} - ${this.name}`;
  }
}
